import { Hosts } from '.';
import productionHosts from './production';

const hosts: Hosts = {
  ...productionHosts,
  CTL_AUTHENTICATOR_SERVER: 'https://aipf-auth-ctl.csg-stg.lunit.in',
  CTL_DATA_SERVER: 'https://aipf-data-ctl.csg-stg.lunit.in',
  CTL_IMAGE_SERVER: 'https://aipf-image-ctl.csg-stg.lunit.in',
  AIPF_PORTAL_DOMAIN: 'https://aipf.tig-stg.lunit.in',
};

export default hosts;
